import { useEffect } from "react";
import { useAppDispatch } from "../app/app.store";
import { setEmployee } from "../app/features/auth/auth.slice";
import { useGetEmployeeMeQuery } from "../app/features/employee/employee.api";
import useAuth from "./useAuth";
import useAuthenticate from "./useAuthenticate";
import useError from "./useError";

export default function useAppBoot() {
  const { isLoading } = useAuthenticate();
  const { isAuthenticated } = useAuth();
  const dispatch = useAppDispatch();
  const {
    isLoading: isLoadingEmployee,
    data: employeeData,
    error,
  } = useGetEmployeeMeQuery(undefined, { skip: !isAuthenticated });
  useError(error, "Failed to fetch get me data");

  useEffect(() => {
    if (employeeData) {
      dispatch(setEmployee(employeeData));
    }
  }, [employeeData, dispatch]);

  return { loading: isLoading || isLoadingEmployee };
}
